import { render, staticRenderFns } from "./MortgageBalance.vue?vue&type=template&id=700493aa&"
import script from "./MortgageBalance.vue?vue&type=script&lang=js&"
export * from "./MortgageBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MortgageBalance.vue"
export default component.exports